module.exports = __webpack_public_path__ + "img/s1_bg1.7d0d9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/UpgradeModal/images/s1_bg1.png
// module id = 2YyW
// module chunks = 47